export default __webpack_public_path__ + "static/media/(23).e4889592.jpg";